export const getDRMWidevinePlayreadyObject = (options, videojs) => {
    return {
      src: options.src,
      type: options.type,
      keySystemOptions: [
          {
              name: 'com.widevine.alpha',
              options: {
                  serverURL: options.licenseUrl,
                  httpRequestHeaders: {
                    'X-AxDRM-Message': options["licenseToken"]
                  }
              }
          },
          {
            name: 'com.microsoft.playready',
            options: {
                serverURL: options.playReadyLicenseUrl,
                httpRequestHeaders: {
                    'X-AxDRM-Message': options["licensePlayreadyToken"]
                }
            }
          }
        ]
  }
}


export const getFairPlayObject = (options, videojs) => {
    return {
      src: options && options.src,
      type: 'application/x-mpegURL',
      keySystems: {
          'com.apple.fps.1_0': {
              getCertificate: (emeOptions, callback) => {
                  let certificateOptions = {
                      uri: options.certificateUrl,
                      method: 'GET',
                      responseType: 'arraybuffer'
                  }
                  videojs.xhr(certificateOptions, (err, response, responseBody) => {
                      console.log(err);
                      if (err) callback(err)
                      callback(null, new Uint8Array(responseBody))
                  })
              },
              getContentId: (emeOptions, initData) => {
                  return options && options.completeskd
              },
              getLicense: (emeOptions, contentId, keyMessage, callback) => {
                  let licenseOptions = {
                      uri: options.licenseUrl,
                      method: 'POST',
                      responseType: 'arraybuffer',
                      body: keyMessage,
                      headers: {
                          'Content-type': 'application/octet-stream',
                          'X-AxDRM-Message': options && options.licenseToken
                      }
                  };
                  videojs.xhr(licenseOptions, (err, response, responseBody) => {
                      console.log(err);
                      if (err) callback(err)
                      callback(null, responseBody)
                  })
              }
          }
      }
  }
}